"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DCATradeUtils = void 0;
const react_1 = require("react");
const decimal_js_1 = __importDefault(require("decimal.js"));
const trade_utils_lib_1 = require("trade_utils_lib");
const trade_utils_lib_2 = require("trade_utils_lib");
exports.DCATradeUtils = {
    useDCABackTest(tradeApi, base, quote, exchange) {
        const [result, setResult] = (0, react_1.useState)(undefined);
        const [loading, setLoading] = (0, react_1.useState)(false);
        const [error, setError] = (0, react_1.useState)('');
        (0, react_1.useEffect)(() => {
            setLoading(true);
            setError('');
            setResult(undefined);
            const subscription = (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.queryAipBackTest(base, quote, exchange), { maxRetryCount: 3 })
                .subscribe(data => {
                setResult(data);
                setLoading(false);
            }, error => {
                setError(error);
                setLoading(false);
            });
            return () => {
                if (subscription) {
                    subscription.unsubscribe();
                }
                setLoading(false);
            };
        }, [base, quote, tradeApi]);
        return [result, loading, error];
    },
    useLimitData(tradeApi, exchange, symbol) {
        const [result, setResult] = (0, react_1.useState)(undefined);
        const [loading, setLoading] = (0, react_1.useState)(false);
        const [error, setError] = (0, react_1.useState)('');
        (0, react_1.useEffect)(() => {
            setResult(undefined);
            if (!symbol) {
                return;
            }
            setLoading(true);
            setError('');
            const subscription = (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.queryAipLimit(symbol, exchange), { maxRetryCount: 3 })
                .subscribe(data => {
                setResult(data);
                setLoading(false);
            }, error => {
                setError(error);
                setLoading(false);
            });
            return () => {
                if (subscription) {
                    subscription.unsubscribe();
                }
                setLoading(false);
            };
        }, [symbol]);
        return [result, loading, error];
    },
    getInvestPerWeek(timeInterval, invest, precision) {
        if (!invest) {
            return undefined;
        }
        // 60 * 60 * 24 * 7
        // 604800
        const value = new trade_utils_lib_1.SafeDecimal(invest).div(new trade_utils_lib_1.SafeDecimal(timeInterval)).mul(604800);
        return trade_utils_lib_2.NumberCommonUtils.formatterDecimal(value, precision).toNumber();
    },
    useInvestPerWeek(period, invest, precision) {
        const [IvPW, setIvPW] = (0, react_1.useState)(0);
        (0, react_1.useEffect)(() => {
            const investNum = trade_utils_lib_2.NumberCommonUtils.formatterDecimal(invest, precision).toNumber();
            setIvPW(this.getInvestPerWeek(period, investNum, precision) || 0);
        }, [period, invest]);
        return IvPW;
    },
    useMinCost(limitData, precision) {
        const [minCost, setMinCost] = (0, react_1.useState)(0);
        (0, react_1.useEffect)(() => {
            setMinCost(0);
            if (!limitData) {
                return;
            }
            if (limitData.cost && limitData.cost.min) {
                const value = trade_utils_lib_2.NumberCommonUtils.formatterDecimal(limitData.cost.min, precision, decimal_js_1.default.ROUND_CEIL).toNumber();
                setMinCost(value);
            }
        }, [limitData]);
        return minCost;
    },
    useError(investPerTime, timeInterval, minCost, balance, precision, $st) {
        const [error, setError] = (0, react_1.useState)(undefined);
        (0, react_1.useEffect)(() => {
            // 1.开始默认有空错误, 没有填入investPerTime
            const investPerTimeNum = trade_utils_lib_2.NumberCommonUtils.formatterDecimal(investPerTime, precision).toNumber();
            if (!investPerTimeNum) {
                setError('');
                return;
            }
            setError(this.checkCreateOrder(investPerTimeNum, timeInterval, minCost, balance, precision, $st));
        }, [minCost, balance, investPerTime, timeInterval]);
        return error;
    },
    checkCreateOrder(investPerTimeNum, timeInterval, minCost, balance, precision, $st) {
        if (!investPerTimeNum) {
            return $st("aip_investment_per_volume_null");
        }
        if (investPerTimeNum < minCost) {
            return $st("aip_per_volume_small_than_min_cost");
        }
        const investPerWeek = this.getInvestPerWeek(timeInterval, investPerTimeNum, precision) || 0;
        if (investPerWeek > balance) {
            return $st("aip_balance_not_enough_to_spend_a_week");
        }
        if (investPerTimeNum > balance) {
            return $st("trading_aip_usdt_not_enough");
        }
        return undefined;
    }
};
